export const getIPGeolocation = () => fetch(`/api/ipapi`).then(response => response.json());
